import React from "react";
import { ShieldCheck } from "lucide-react";

/**
 * Reusable VerifiedBadge — drop in next to any user / business name to show
 * the blue checkmark when the entity has been verified by iCaard admin.
 */
export default function VerifiedBadge({ size = 14, className = "" }) {
  return (
    <span
      title="Verified by iCaard"
      data-testid="verified-badge"
      className={`inline-flex items-center justify-center w-5 h-5 rounded-full bg-[#0EA5E9] text-white ${className}`}
      style={{ width: size + 6, height: size + 6 }}
    >
      <ShieldCheck size={size} strokeWidth={3} />
    </span>
  );
}
